// extracted by mini-css-extract-plugin
export default {"courseTime":"Further_courseTime__l5d7M","courseTimeButton":"Further_courseTimeButton__dZFh1"};